import logApi from '../../api/logApi';

const state = {
    logs: [],
    latestDocuments: []
};

const actions = {
    async getLogs({ commit },obj) {
        return new Promise((resolve, reject) => {
            logApi
                .get(obj)
                .then((response) => {
                    if (response.status == 200) {
                        commit("SET_LOGS", response.data.data);
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
        })
    },
    getListlogs({ commit }) {
        return new Promise((resolve, reject) => {
            logApi.Listlogs().then((response) => {
                if (response.status == 200) {
                    resolve(response)
                    commit("SET_LOGS", response.data)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    logsGrouped() {
        return new Promise((resolve, reject) => {
            logApi.logsGrouped().then((response) => {
                if (response.status == 200) {
                    resolve(response)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    getLatestDocuments() {
        return new Promise((resolve, reject) => {
            logApi.latestDocument().then(response => {
                if(response.status == 200) {
                    resolve(response);
                }
                reject(response);
            }).catch(error => {
                reject(error);
            })
        })
    }
}

const mutations = {
    SET_LOGS: (state, logs) => state.logs = logs,
    SET_LATEST_DOCUMENTS: (state, latestDocuments) => state.latestDocuments = latestDocuments
}

export default {
    state,
    actions,
    mutations
}